<template>
    <div class="main">
        <c-panel title="Acesso com Certificado Digital (e-CPF)" titleIcon="fas fa-id-card">
            <ecpf @autenticado="concluido"></ecpf>
        </c-panel>
    </div>
</template>
<script>
/*
 * A extensão é OBRIGATÓRIA aqui.
 *
 * Esta pasta tem `ecpf.js` (os helpers de criptografia, só com exports nomeados) e
 * `ecpf.vue` (o componente). O webpack resolve `./ecpf` para o `.js` primeiro, que não tem
 * `default` — o componente virava `undefined`, `<ecpf>` caía como "unknown custom element" e
 * a tela ficava só com o título, sem formulário nenhum.
 *
 * O `npm run build` NÃO reprova isso: sai um aviso no meio do log e o bundle é gerado. Só
 * abrindo a tela é que aparece.
 */
import ecpf from "./ecpf.vue"
export default {
    components: { ecpf },
    methods: {
        concluido (r) {
            window.eventBus.$emit('alert', {
                msg: 'Certificado validado para o CPF ' + r.cpf + '.', type: 'success'
            })
        }
    }
}
</script>
